import React from 'react';
import { CreativePreferences as SharedCreativePreferences } from '@egreact/shared';
import Navbar from '../../components/Navbar/Navbar';
import StoreToken from '../../components/StoreToken';
import './configure';

// The client fills the form here, so nothing is forced read-only: the payload
// and the query string still decide, as they did before the move.
const CreativePreferences = () => (
  <SharedCreativePreferences
    useStoreToken={StoreToken}
    // No `location`: given one, the Navbar builds a tokenised URL to compare
    // against, and that builder redirects to login while the token is still in
    // the address bar rather than in storage. Without it the Navbar
    // short-circuits, and its logo links to the app root.
    chrome={<Navbar title="Dashboard" />}
  />
);

export default CreativePreferences;
